// Visuell rendering av ImageBlock. Bilden centreras med padding som matchar
// serialize.ts. Saknas href visas bara <img>, annars wrappas i klick-länk.

import { Box } from '@mui/material';
import { ImageBlock } from '../types';

type Props = { block: ImageBlock };

export const ImageBlockView = ({ block }: Props) => {
  const maxWidth = block.width ? `${block.width}px` : '600px';
  const img = (
    <Box
      component='img'
      src={block.src}
      alt={block.alt}
      sx={{
        display: 'block',
        width: '100%',
        maxWidth,
        height: 'auto',
        border: 0,
        mx: 'auto',
      }}
    />
  );
  return (
    <Box sx={{ p: block.fullBleed ? 0 : '12px 30px', textAlign: 'center' }}>
      {block.href ? (
        <a href={block.href} target='_blank' rel='noopener noreferrer' style={{ display: 'inline-block', width: '100%' }}>
          {img}
        </a>
      ) : (
        img
      )}
    </Box>
  );
};

export default ImageBlockView;
